import React from 'react';

export default function PolicyDetailSkeleton() {
  return (
    <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 py-8 animate-pulse">
      <div className="h-4 w-48 bg-muted rounded mb-6" />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 space-y-5">
          <div className="bg-card border border-border rounded-2xl p-6 space-y-4">
            <div className="flex gap-4">
              <div className="w-14 h-14 bg-muted rounded-xl" />
              <div className="flex-1 space-y-2">
                <div className="h-4 w-24 bg-muted rounded" />
                <div className="h-6 w-48 bg-muted rounded" />
                <div className="h-3 w-32 bg-muted rounded" />
              </div>
            </div>
            <div className="grid grid-cols-3 gap-4">
              {[1, 2, 3]?.map((i) => (
                <div key={`skel-stat-${i}`} className="h-16 bg-muted rounded-xl" />
              ))}
            </div>
          </div>
          <div className="bg-card border border-border rounded-2xl p-6 space-y-3">
            <div className="flex gap-4 mb-4">
              {[1, 2, 3, 4]?.map((i) => (
                <div key={`skel-tab-${i}`} className="h-8 w-24 bg-muted rounded-lg" />
              ))}
            </div>
            {[1, 2, 3, 4, 5]?.map((i) => (
              <div key={`skel-row-${i}`} className="h-12 bg-muted rounded-lg" />
            ))}
          </div>
        </div>
        <div className="space-y-4">
          <div className="h-64 bg-muted rounded-2xl" />
          <div className="h-48 bg-muted rounded-2xl" />
        </div>
      </div>
    </div>
  );
}